import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgAdditionalTweaks = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 42,
	height: 32,
	viewBox: "0 0 42 32",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "inherit",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("path", { d: "M8 24.222v2.89h8.667v-2.89H8zM8 6.89v2.889h14.444v-2.89H8zM22.444 30v-2.889H34v-2.889H22.444v-2.889h-2.888V30h2.888zm-8.666-17.333v2.889H8v2.888h5.778v2.89h2.889v-8.667h-2.89zM34 18.444v-2.888H19.556v2.888H34zm-8.667-5.777h2.89v-2.89H34V6.89h-5.778V4h-2.889v8.667z" })
	})
});
export default SvgAdditionalTweaks;
